import {OAuthPageContent} from '@/src/features/auth/core/oauth-types'
import {ThirdPartyWrapper} from '@/src/features/auth/ui/third-party/wrapper'
import React, {memo} from 'react'
import {getInjection} from '@runlab/di'

interface ThirdPartyContainerProps {
  providers: OAuthPageContent['oauth_providers']
}

export const ThirdPartyContainer = ({providers}: ThirdPartyContainerProps) => {
  return (
    <ThirdPartyWrapper>
      {providers.map(provider => (
        <ThirdPartyBtn key={provider} provider={provider} />
      ))}
    </ThirdPartyWrapper>
  )
}

const ThirdPartyBtn = memo(function Component({
   
  provider,
}: {
  provider: ArrayItem<OAuthPageContent['oauth_providers']>
}) {
  return getInjection('ThirdPartyOAuthComponentFactory')(provider)
})
